import React from 'react'

const PosShiftsPage = () => {
    return (
        <div>posShiftPage</div>
    )
}

export default PosShiftsPage